import { AddLocationModel } from '../models/add-location.model';
import { AddLocationDto } from '../dtos/add-location.dto';

export class AddLocationMapper {
  static toDto(addLocationModel: AddLocationModel): AddLocationDto {
    return {
      name: addLocationModel.name,
      externalId: addLocationModel.externalId,

      contact: {
        street: addLocationModel.street,
        zipCode: addLocationModel.zipCode,
        city: 'CH',
        country: addLocationModel.country,
        emailAddress: addLocationModel.emailAddress
      }
    };
  }
}
